<template>
<div>
  <b-row>
    <b-col>
      <div class="alert alert-danger" v-if="!!error">{{ error }}</div>
    </b-col>
  </b-row>

  <b-row>
    <b-col>
      <label class="justify-content-start">{{ trans('program') }}</label>
      <b-form-select
        size="sm"
        :options="programsForSelect"
        v-model="programId1"
        :disabled="isLoading"
      />
    </b-col>
    <b-col>
      <label class="justify-content-start">{{ trans('compare_to_another_program') }}</label>
      <b-form-select
        size="sm"
        :options="programsForSelect"
        v-model="programId2"
        :disabled="isLoading"
      />
    </b-col>
  </b-row>

  <b-row class="mt-4">

    <b-col>
      <b-row v-if="programStats1 != null">
        <b-col cols="6">
          <p>
            <strong>{{ trans('spots_available') }}</strong>:
            {{ programStats1.spots }}
            <br/>
            <strong>{{ trans('filled') }}</strong>:
            {{ programStats1.filled }}
            <br/>
            <strong>{{ trans('remaining') }}</strong>:
            {{ programStats1.remaining }}
          </p>
        </b-col>
        <b-col cols="6">
          <doughnut :labels="programDoughnutLabels" :data="programDoughnutData1" />
        </b-col>
      </b-row>
      <b-row v-if="programStats1 != null">
        <b-col>
          <activities :stats="activityStats1" />
        </b-col>
      </b-row>
    </b-col>

    <b-col>
      <b-row v-if="programStats2 != null">
        <b-col cols="6">
          <p>
            <strong>{{ trans('spots_available') }}</strong>:
            {{ programStats2.spots }}
            <br/>
            <strong>{{ trans('filled') }}</strong>:
            {{ programStats2.filled }}
            <br/>
            <strong>{{ trans('remaining') }}</strong>:
            {{ programStats2.remaining }}
          </p>
        </b-col>
        <b-col cols="6">
          <doughnut :labels="programDoughnutLabels" :data="programDoughnutData2" />
        </b-col>
      </b-row>
      <b-row v-if="programStats2 != null">
        <b-col>
          <activities :stats="activityStats2" />
        </b-col>
      </b-row>
    </b-col>

  </b-row>

</div>
</template>

<script>
import Doughnut from './DoughnutComponent'
import Activities from './ActivitiesProgressComponent'

export default {
  components: {
    doughnut: Doughnut,
    activities: Activities,
  },
  props: [
    'organization',
    'amilia_organization',
  ],
  data() {
    return {
      trans: trans,
      numeral: numeral,
      isLoading: false,
      error: null,
      settings: this.loadSettings(),

      programs: null,
      programDoughnutLabels: [trans('filled'), trans('remaining')],

      programId1: null,
      activities1: null,

      programId2: null,
      activities2: null,
    }
  },
  computed: {
    programsForSelect() {
      let result = [{
        value: null,
        text: trans('select_a_program'),
      }];

      if (this.programs == null) return result
      this.programs.forEach(p => {
        result.push({
          value: p.id,
          text: p.name,
        })
      })

      return result
    },
    programStats1() {
      return this.calculateProgramStats(1)
    },
    programStats2() {
      return this.calculateProgramStats(2)
    },
    programDoughnutData1() {
      return this.programStats1 ? [this.programStats1.filled, this.programStats1.remaining] : null
    },
    programDoughnutData2() {
      return this.programStats2 ? [this.programStats2.filled, this.programStats2.remaining] : null
    },
    activityStats1() {
      return this.calculateActivityStats(1)
    },
    activityStats2() {
      return this.calculateActivityStats(2)
    },
  },
  watch: {
    programId1(value) {
      this.changeProgram(1, value)
    },
    programId2(value) {
      this.changeProgram(2, value)
    },
  },
  methods: {
    loadSettings() {
      return _.getObjectFromLocalStorage('dailyRegistrationsReportSettings' + this.organization.id) || {
        programId1: null,
        programId2: null,
      }
    },
    saveSettings() {
      window.localStorage['dailyRegistrationsReportSettings' + this.organization.id] = JSON.stringify(this.settings)
    },
    changeProgram(no, id) {
      this.settings['programId'+no] = id
      this.saveSettings()
      this.loadActivities(no)
    },
    calculateProgramStats(no) {
      let programId = this['programId'+no]
      let activities = this['activities'+no]
      if (programId == null || activities == null) return null
      return activities.reduce((r, a) => {
        r.spots += a.max_attendance < 9999 ? a.max_attendance : 0
        r.filled += a.spots_reserved
        r.remaining += a.spots_remaining
        return r
      }, {
        spots: 0,
        filled: 0,
        remaining: 0,
      })
    },
    calculateActivityStats(no) {
      let programId = this['programId'+no]
      let activities = this['activities'+no]
      if (programId == null || activities == null) return null

      let blank = {
        type: 'activity',
        id: null,
        name: null,
        spots: 0,
        filled: 0,
        remaining: 0,
      }

      let map = {}
      activities.forEach(o => {
        let a = _.assign({}, blank, {
          uid: 'a' + o.id,
          id: o.id,
          name: o.name,
          spots: o.max_attendance < 9999 ? o.max_attendance : 0,
          filled: o.spots_reserved,
          remaining: o.spots_remaining,
          unlimited: o.max_attendance > 9999
        })
        let s = map['s'+o.subcategory_id] || _.assign({}, blank, {
          uid: 's' + o.id,
          type: 'subcategory',
          id: o.subcategory_id,
          name: o.subcategory_name,
          unlimited: a.unlimited,
        })
        s.spots += a.spots
        s.filled += a.filled
        s.remaining += a.remaining
        s.unlimited == s.unlimited && a.unlimited
        let c = map['c'+o.category_id] || _.assign({}, blank, {
          uid: 'c' + o.id,
          type: 'category',
          id: o.category_id,
          name: o.category_name,
          unlimited: a.unlimited,
        })
        c.spots += a.spots
        c.filled += a.filled
        c.remaining += a.remaining
        c.unlimited = c.unlimited && a.unlimited
        if (!map['c'+o.category_id]) map['c'+o.category_id] = c
        if (!map['s'+o.subcategory_id]) map['s'+o.subcategory_id] = s
        map['a'+o.id] = a
      })

      return _.values(map)
    },
    loadActivities(no) {
      this['activities'+no] = null
      if (this['programId'+no] == null) return
      let url = `/organization/${this.organization.id}/amilia/programs/${this['programId'+no]}/activities`
      this.isLoading = true
      axios.get(url)
      .then(response => {
        this.isLoading = false
        if (!response.data || response.data.length == 0) {
          this.error = trans('no_activities')
          return
        }
        this['activities'+no] = response.data
      })
      .catch(error => {
        this.isLoading = false
        if (error.response.data) {
          this.error = error.response.data.message
        } else {
          this.error = error
        }
      })
    },
    loadPrograms() {
      this.programs = null
      let url = `/organization/${this.organization.id}/amilia/programs`
      this.isLoading = true
      axios.get(url)
      .then(response => {
        this.isLoading = false
        if (!response.data || response.data.length == 0) {
          this.error = trans('no_programs')
          return
        }
        this.programs = response.data
        this.programs.forEach((program) => {
          if (program.id == this.settings.programId1) this.programId1 = program.id
          if (program.id == this.settings.programId2) this.programId2 = program.id
        })
      })
      .catch(error => {
        this.isLoading = false
        if (error.response.data) {
          this.error = error.response.data.message
        } else {
          this.error = error
        }
      })
    },
  },
  mounted() {
    window.co = this;
    this.loadPrograms()
  }
}
</script>
